import { createAction } from 'redux-actions'
import * as constants from './constants'

export const sendDriftAppMetric = createAction(constants.SEND_DRIFT_APP_METRIC)
export const sendDriftAppMetricPending = createAction(constants.SEND_DRIFT_APP_METRIC_PENDING)
export const sendDriftAppMetricFailed = createAction(constants.SEND_DRIFT_APP_METRIC_FAILED)
export const sendDriftAppMetricSuccess = createAction(constants.SEND_DRIFT_APP_METRIC_SUCCESS)

export const enterRootAppRoute = createAction(constants.ENTER_ROOT_APP_ROUTE)
export const startConversationsAppTimer = createAction(constants.START_CONVERSATIONS_APP_TIMER)
export const recordConversationsAppTimer = createAction(constants.RECORD_CONVERSATIONS_APP_TIMER)
export const hitConversationsAppRenderCheckpoint = createAction(constants.HIT_CONVERSATIONS_APP_RENDER_CHECKPOINT)

export const trackPresenceLoadTime = createAction(constants.TRACK_PRESENCE_LOAD_TIME)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/driftAppMetrics/actions.js